<template>
    <!-- 附件 弹框 -->
    <el-dialog
        append-to-body
        :closeOnClickModal='false'
        class="imgDialog "
        title="附件查看"
        :visible="true"
        :before-close="beforeClose"
        width="40%">

        <div class="attachmentTitle" v-if="imgArr.length">
            <span> {{ updateUserName ? '上传人：' + updateUserName : '' }}</span>
            <div :style="{paddingLeft: updateUserName ? '70px' : ''}">{{ carouselIndex + 1 + ' / ' + imgArr.length}}</div>
            <span>{{ updateTime ? '上传时间：'+ updateTime : '' }}</span>
        </div>
        <div class="no-data" v-else>暂无附件信息</div>

        <div class="attachmentLeft" v-show="imgArr.length">
            <div style="height: 300px;">
                <ul id='viewers' style="display: none;">
                    <li v-for='(item, index) in imgArr' :key='index'>
                        <img :src="item.path">
                    </li>
                </ul>
            </div>
        </div>

        <div class="uploader" v-if="imgArr.length">
            <i class="el-icon-delete" v-if="isDeleteBtn" @click="deleteBtn"></i>
            <i class="el-icon-download" @click="downloadBtn"></i>
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import lodash from 'lodash';

export default {
    props: {
        attachmentShow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        attachmentList: {
            type: Array,
            default () {
                return [];
            }
        },
        isDeleteBtn: {
            type: Boolean,
            default () {
                return true;
            }
        }
    },
    data() {
        return {
            dialogLoading: {}, // 弹框loading实例
            viewer: {},
            carouselIndex: 0, // 轮播图当前的索引
            imgArr: [],
            updateUserName: '',
            updateTime: ''
        };
    },
    mounted () {
        this.imgArr = lodash.cloneDeep(this.attachmentList);
        this.updateViewer();
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    methods: {
        beforeClose() {
            this.$emit('update:attachmentShow', false);
        },
        updateViewer() {
            this.carouselIndex = 0;
            this.updateInfo();
            this.$nextTick(() => {
                this.initViewer();
            });
        },
        updateInfo () {
            this.updateUserName = this.imgArr[this.carouselIndex] ? this.imgArr[this.carouselIndex].createUserCode : '';
            this.updateTime = this.imgArr[this.carouselIndex] ? this.imgArr[this.carouselIndex].createTime : '';
        },
        // 删除图片
        deleteBtn () {
            if (this.imgArr.length) {
                this.viewer.destroy();
                this.imgArr.splice(this.carouselIndex, 1);
                this.$emit('deleteImg', this.carouselIndex);
                this.$message.success('删除成功');
                this.updateViewer();
            }
        },
        downloadBtn () {
            window.location = this.imgArr[this.carouselIndex].path;
        },
        initViewer() {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: false,
                button: true,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === 0) {
                                this.carouselIndex = this.imgArr.length - 1;
                            } else {
                                this.carouselIndex -= 1;
                            }
                            this.updateInfo();
                            this.viewer.prev(true);
                        }
                    },
                    reset: barOptions,
                    next: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === this.imgArr.length - 1) {
                                this.carouselIndex = 0;
                            } else {
                                this.carouselIndex += 1;
                            }
                            this.updateInfo();
                            this.viewer.next(true);
                        }
                    },
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        }
    },
    beforeDestroy() {
        this.viewer.destroy();
    }
};
</script>

<style lang="less">
.imgDialog {
    .attachmentTitle {
        margin: 10px 0;
        display: flex;
        justify-content: space-between;
    }
    .attachmentLeft {
        position: relative;
        .loadingBox {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #fff;
            z-index: 1000;
            .progress {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .carousel {
            text-align: center;
            .receiveImgs {
                height: 100%;
            }
        }
    }
    .paddingLeft {
        padding-left: 70px;
    }
    .uploader {
        padding-top: 15px;
        text-align: center;

        > div {
            display: inline-block;
        }
        .pictures {
            border-radius: 4px;
            border: 1px dashed #00bcbf;
            color: #00bcbf;
            width: 20px;
            line-height: 20px;
        }
        > i {
            cursor: pointer;
            color: #00bcbf;
            font-size: 22px;
            vertical-align: middle;
        }
        .el-icon-delete {
            margin-right: 30px;
        }
        .el-icon-download{
            margin-left: 4px;
        }
        .el-upload{
            text-align: center;
        }
    }
}
</style>
